﻿function getForm() {
    return $("[data-air-index-vehicle-form]");
}

function submitForm() {
    const form = getForm();
    form.submit();
}

function addToCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("compare-list-add-id");
    addVehicle(data);
}

function addVehicle(id) {
    $.get("/emissions-data/compare-list/handle/add/" + id, function (response) {
        if (response == 0) {
            const form = getForm();
            form.submit();
        } else if (response == 1) {
            alert("Maximum of 5 vehicles.");
        } else if (response == 2) {
            alert("Already added to the compare list. Please select another vehicle.");
        } else {
            alert("Error");
        }
    });
}

function removeFromCompareList(event) {
    event.preventDefault();
    const button = $(event.currentTarget);
    const data = button.data("compare-list-remove-id");
    removeVehicle(data);
}

function removeVehicle(id) {
    $.get("/emissions-data/compare-list/handle/remove/" + id, function (response) {
        const form = getForm();
        form.submit();
    });
}

export function setupAirIndexVehiclePage() {
    if ($('[data-air-index-vehicle-page]').length) {

        $(document).on("click", "[data-compare-list-add-id]", addToCompareList);
        $(document).on("click", "[data-compare-list-remove-id]", removeFromCompareList);
    }
}